<template>
  <div>
    <div class="infokv">
      <label style="line-height:32px">子项列表：</label>
      <div >
        <div class="flexfs flexwarp">
          <Tag
            size="medium"
            color="blue"
            v-for="(item) in row.tag"
            :key="item.itemValue"
            :name="item.itemName"
            class="mr-16 mb-16"
            >{{ item.itemName }} ({{ item.itemValue }})</Tag
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    row: Object,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss">
</style>